<template>
  <div class="Bgc-white">
    <Header />
    <div class="container espacio justify-content-center">
      <div class="row w-100">
        <div class="col-12">

          <!-- datos -->
          <form @submit.prevent="">
            <div class="datos">
              <!-- dato 1 -->
              <div class="dato">
                <div class="datoHeader">
                  <p class="datoTitle">
                    {{ $t('language.posadasCorporate.infoPersonalEditar.editInfoPersonal') }}
                  </p>
                </div>
                <div class="datoBody" role="tablist">

                  <!-- Datos personales -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="infoPersonal.datosPersonales"
                      :class="(infoPersonal.iconoActivo == 0) ? 'camposActive' : ''"
                      @click="(infoPersonal.iconoActivo == 0) ? infoPersonal.iconoActivo = 100 : infoPersonal.iconoActivo = 0"
                      v-b-toggle="'datosPersonales'">
                      <i class="icon-user"></i>
                      {{ $t('language.posadasCorporate.infoPersonalEditar.datosPersonales') }}
                      <i class="navi icon-up" :class="(infoPersonal.iconoActivo == 0) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(infoPersonal.iconoActivo == 0) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!infoPersonal.datosPersonales"
                      @click="(infoPersonal.iconoActivo == 0) ? infoPersonal.iconoActivo = 100 : infoPersonal.iconoActivo = 0"
                      v-b-toggle="'datosPersonales'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.infoPersonalEditar.datosPersonales') }}
                      <span class="editarDatos"
                        @click="[infoPersonal.datosPersonales = true, formulario1.personales = false]">{{
                            $t('language.posadasCorporate.infoPersonalEditar.editar')
                        }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosPersonales" visible accordion="my-accordion" role="tabpanel">
                      <div class="row">

                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.nombreUsu') }}*</label>
                          <input type="text" v-model="infoPersonal.nombreUsuario" disabled>
                        </div>
                      </div>

                      <div class="row segundaIlera">
                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.nombre') }}*</label>
                          <input type="text" v-model="infoPersonal.nombres" v-onlyText maxlength="30">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.apePaterno') }}*</label>
                          <input type="text" v-model="infoPersonal.apellidoP" v-onlyText maxlength="30">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.apeMaterno') }}</label>
                          <input type="text" v-model="infoPersonal.apellidoM" v-onlyText maxlength="30">
                        </div>

                        <!-- informacion empresa -->
                        <div class="form-element col-12 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.numEmpAgente') }}</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.infoPersonalEditar.maxCaracter30')"
                            maxlength="30" v-model="realNumeroEmple" class="inputUppercase">
                        </div>
                        <div class="form-element col-6 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.numeroFR') }}</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.infoPersonalEditar.maxCaracter20')"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            maxlength="20" v-model="infoPersonal.numFiesta" class="inputUppercase" v-alphanumeric>
                        </div>
                        <div class="form-element col-6 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.numApreClub') }}</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.infoPersonalEditar.maxCaracter20')"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            maxlength="20" v-model="infoPersonal.numApreciare" class="inputUppercase" v-alphanumeric>
                        </div>
                        <div class="form-element col-12 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.controCostos') }}</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.infoPersonalEditar.maxCaracter20')"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            maxlength="20" v-model="infoPersonal.numCentro" class="inputUppercase" v-alphanumeric>
                        </div>
                        <div class="col-12">
                          <label for="" class="notas">*{{
                              $t('language.posadasCorporate.infoPersonalEditar.camposRequeridos')
                          }}</label>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosPersonales'"
                          v-b-toggle.datosContacto>
                          <button class="button"
                            @click="[infoPersonal.datosPersonales = false, infoPersonal.datosContacto = true, formulario1.personales = true]"
                            :disabled="isDisabledPersonales">{{
                                $t('language.posadasCorporate.infoPersonalEditar.contDatContacto')
                            }}</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Datos de contacto -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="infoPersonal.datosContacto"
                      :class="(infoPersonal.iconoActivo == 1) ? 'camposActive' : ''"
                      @click="(infoPersonal.iconoActivo == 1) ? infoPersonal.iconoActivo = 100 : infoPersonal.iconoActivo = 1"
                      v-b-toggle="'datosContacto'" accordion="my-accordion" role="tabpanel">
                      <i class="icon-location"></i>
                      {{ $t('language.posadasCorporate.infoPersonalEditar.datosContacto') }}
                      <i class="navi icon-up" :class="(infoPersonal.iconoActivo == 1) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(infoPersonal.iconoActivo == 1) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!infoPersonal.datosContacto"
                      @click="(infoPersonal.iconoActivo == 1) ? infoPersonal.iconoActivo = 100 : infoPersonal.iconoActivo = 1"
                      v-b-toggle="'datosContacto'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.infoPersonalEditar.datosContacto') }}
                      <span class="editarDatos"
                        @click="[infoPersonal.datosContacto = true, formulario1.contacto = false]">{{
                            $t('language.posadasCorporate.infoPersonalEditar.editar')
                        }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosContacto" accordion="my-accordion" role="tabpanel">
                      <div class="row contactoInfo">

                        <!-- Tipo de teléfono -->
                        <div class="form-element col-12 col-lg-6">
                          <label>{{ $t('language.posadasCorporate.infoPersonalEditar.tipoTelefono') }}*</label><br>
                          <label for="celular" class="col-4 pl-0 radio">
                            <input type="radio" id="celular" class="hidden" value="MOB" v-model="pickedTelelefonoUf">
                            <span class="label"></span><span class="moneda">{{
                                $t('language.posadasCorporate.infoPersonalEditar.celular')
                            }}</span>
                          </label>
                          <label for="casa" class="col-4 pl-0 radio">
                            <input type="radio" id="casa" class="hidden" value="HOM" v-model="pickedTelelefonoUf">
                            <span class="label"></span><span class="moneda">{{
                                $t('language.posadasCorporate.infoPersonalEditar.casa')
                            }}</span>
                          </label>
                          <label for="oficina" class="col-4 pl-0 radio">
                            <input type="radio" id="oficina" class="hidden" value="BUS" v-model="pickedTelelefonoUf">
                            <span class="label"></span><span class="moneda">{{
                                $t('language.posadasCorporate.infoPersonalEditar.oficima')
                            }}</span>
                          </label>
                        </div>

                        <!-- Núm. telefónico Cel-->
                        <div class="form-element col-12 col-lg-6">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.numTelefonico') }}*</label>
                          <!--
                            <input type="text" :placeholder="$t('language.posadasCorporate.infoPersonalEditar.digitos10')" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10" v-model="infoPersonal.numTelefonico" v-onlyNumbers>
                          -->
                          <!-- KB47296 Start -->
                          <vue-tel-input :value="infoPersonal.numTelefonico"
                            @validate="handleValidatePhoneNumber" @input="handleOnInputPhoneNumber"
                            @blur="handleOnBlurPhoneNumber" @country-changed="handleCountryChanged" :key="telInput"></vue-tel-input>
                          <!-- KB47296 End -->
                        </div>

                        <!-- Correo electrónico* -->
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.email') }}*</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.infoPersonalEditar.ejemplo') + '@' + $t('language.posadasCorporate.infoPersonalEditar.correo') + '.com'"
                            v-model="mailContacto" v-email :class="{ 'is-invalid': (!$v.mailContacto.email) }">
                          <span class="notas" v-if="!$v.mailContacto.email">{{
                              $t('language.posadasCorporate.infoPersonalEditar.emailNoValido')
                          }}</span>
                        </div>


                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.confEmail')
                          }}*</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.ejemplo') + '@' + $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.correo') + '.com'"
                            v-model="mailContactoConfirm" v-email maxlength="50"
                            :class="{ 'is-invalid': (!$v.mailContactoConfirm.email || !emailMatch) }">
                          <span class="notas" v-if="!$v.mailContactoConfirm.email">{{
                              $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.emailInvalid')
                          }}.</span>
                          <span class="notas" v-if="!emailMatch">
                            {{ $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.emailCopy') }}.
                          </span>
                        </div>

                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.sendCopyConfi') }}</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.infoPersonalEditar.ejemplo') + '@' + $t('language.posadasCorporate.infoPersonalEditar.correo') + '.com'"
                            v-model="infoPersonal.mailContactoConfirmacion" v-email
                            :class="{ 'is-invalid': (!$v.infoPersonal.mailContactoConfirmacion.email) }">
                          <span class="notas" v-if="!$v.infoPersonal.mailContactoConfirmacion.email">{{
                              $t('language.posadasCorporate.infoPersonalEditar.emailNoValido')
                          }}</span>
                          <span class="notas">{{ $t('language.posadasCorporate.infoPersonalEditar.copy1Confi') }}:
                            reservacionescorporate@posadas.com</span>
                        </div>
                        <div class="form-element col-12">
                          <label class="detalle-usuario__subtitulo PC-text--size16">{{
                              $t('language.posadasCorporate.reservacionesRegistro.newAddress')
                          }}</label><br>
                        </div>

                        <!-- Calle numero -->
                        <div class="form-element col-12 col-lg-6">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.calleNumero') }}</label>
                          <input type="text" v-model="infoPersonal.direccion" v-alphanumericAddress
                            class="inputUppercase">
                        </div>

                        <div class="form-element col-6 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.colonia') }}</label>
                          <input type="text" v-model="infoPersonal.colonia" v-alphanumericAddress
                            class="inputUppercase">
                        </div>

                        <!-- Código Postal -->
                        <div class="form-element col-6 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.codigoPostal') }}</label>
                          <input type="text" v-model="infoPersonal.codigoPostal" v-alphanumeric class="inputUppercase">
                        </div>

                        <!-- Pais -->
                        <div class="form-element col-6 col-lg-3" v-click-outside="outsidePais">
                          <label>{{ $t('language.posadasCorporate.infoPersonalEditar.pais') }}*</label>
                          <div class="contenidoSearch" @click="[infoPersonal.pais = true]">
                            <i class="search-icons icon-search" v-if="!infoPersonal.pais"></i>
                            <i class="search-icons icon-close pointer" v-if="infoPersonal.pais"
                              @click="realCountry = '', resetSelectedPais()"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.infoPersonalEditar.seleccionar')"
                              @click="filteredListPaises"  v-model="realCountry">
                          </div>

                          <div class="card buscadorCard vb" v-if="infoPersonal.pais" v-bar>
                            <div>
                              <div class="buscador" v-for="pais in filteredListPaises" :key="pais.id">
                                <p class="mb-1 nombre" @click="[cambiaPais(pais.nombre), infoPersonal.pais = false]"
                                  v-html="$options.filters.resalt(pais.nombre, realCountry)">
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Estado -->
                        <div class="form-element col-6 col-lg-3" v-click-outside="outsideEstado">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.estado') }}</label>
                          <div class="contenidoSearch">
                            <i class="search-icons icon-search" v-if="!infoPersonal.estado"></i>
                            <i class="search-icons icon-close pointer" v-if="infoPersonal.estado"
                              @click="infoPersonal.estadoSeleccionado = ''"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.infoPersonalEditar.seleccionar')"
                              :disabled="isDisabledEstado" @click="infoPersonal.estado = true, filteredListEstado()"
                              v-model="infoPersonal.estadoSeleccionado">
                          </div>

                          <div class="card buscadorCard vb" v-if="infoPersonal.estado" v-bar>
                            <div>
                              <div class="buscador" v-for="estado in filteredListEstado" :key="estado.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaEstado(estado.nombre), infoPersonal.estado = false]"
                                  v-html="$options.filters.resalt(estado.nombre, infoPersonal.estadoSeleccionado)">
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Estado -->
                        <div class="form-element col-6 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.infoPersonalEditar.ciudad') }}</label>
                          <input type="text" v-model="infoPersonal.ciudad" v-alphanumericAddress class="inputUppercase">
                        </div>

                        <div class="col-12 mb-2">
                          <label for="" class="notas">*{{
                              $t('language.posadasCorporate.infoPersonalEditar.camposRequeridos')
                          }}</label>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosContacto'" v-b-toggle.contrasena>
                          <button class="button"
                            @click="[infoPersonal.datosContacto = false, formulario1.contacto = true]"
                            :disabled="isDisabledContacto">{{
                                $t('language.posadasCorporate.infoPersonalEditar.contContRegis')
                            }}</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Contraseña registrada -->
                  <div class="campos acompanante">
                    <p class="tituloDatos" v-if="infoPersonal.contrasena"
                      :class="(infoPersonal.iconoActivo == 2) ? 'camposActive' : ''"
                      @click="(infoPersonal.iconoActivo == 2) ? infoPersonal.iconoActivo = 100 : infoPersonal.iconoActivo = 2"
                      v-b-toggle="'contrasena'" accordion="my-accordion" role="tabpanel">
                      <i class="icon-lock"></i>
                      {{ $t('language.posadasCorporate.infoPersonalEditar.contRegis') }}
                      <i class="navi icon-up" :class="(infoPersonal.iconoActivo == 2) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(infoPersonal.iconoActivo == 2) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!infoPersonal.contrasena"
                      @click="(infoPersonal.iconoActivo == 2) ? infoPersonal.iconoActivo = 100 : infoPersonal.iconoActivo = 2"
                      v-b-toggle="'contrasena'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.infoPersonalEditar.contRegis') }}
                      <span class="editarDatos"
                        @click="[infoPersonal.contrasena = true, formulario1.contrasenaU = false]">{{
                            $t('language.posadasCorporate.infoPersonalEditar.editar')
                        }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="contrasena" accordion="my-accordion" role="tabpanel">
                      <div class="row">

                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-6 relative">
                          <label for="password">{{ $t('language.posadasCorporate.infoPersonalEditar.contrasena')
                          }}*</label>
                          <input id="password" class="form-control password" :type="passwordFieldType"
                            :class="{ 'is-invalid': (!passwordNot10M) }" @click.stop="isModalPass = false"
                            @blur="outsidePass" v-model="contrasenaUsuario">
                          <p class="__eyeIcon buttonEye" :class="[openEye]" @click="switchVisibility"></p>
                        </div>
                        <div class="form-element col-12 col-lg-6 relative">
                          <label for="passwordConfirm">{{
                              $t('language.posadasCorporate.infoPersonalEditar.confirContra')
                          }}*</label>
                          <input id="passwordConfirm" class="form-control password"
                            :class="{ 'is-invalid': (!passwordMatch || !passwordNot10) }"
                            :type="passwordFieldTypeConfirm" @click.stop="isModalPass = false" @blur="outsidePass"
                            v-model="contrasenaConfirma">
                          <p class="__eyeIcon buttonEye" :class="[openEyeConfirm]" @click="switchVisibilityConfirm"></p>
                          <span class="notas" v-if="!passwordMatch">
                            {{ $t('language.posadasCorporate.infoPersonalEditar.theSame') }}.
                          </span>
                        </div>


                        <div class="col-12 mb-2">

                          <label for="" class="notas"
                            v-if="contrasenaConfirma.length < 10 || contrasenaUsuario.length < 10">
                            {{ $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.text2') }}
                          </label>
                          <br>
                          <label for="" class="notas">*{{
                              $t('language.posadasCorporate.infoPersonalEditar.camposRequeridos')
                          }}</label>
                        </div>

                        <div v-if="enableUser" class="col-12 mb-2">
                          <input type="checkbox" v-model="infoPersonal.desHabilitarUsuario">
                          <label>{{ $t('language.posadasCorporate.infoPersonalEditar.text2') }}</label>
                        </div>


                      </div>
                    </b-collapse>
                  </div>

                </div>
              </div>

            </div>
            <!-- Botones -->
            <div class="row botones d-flex justify-content-end">
              <div class="col-12 col-lg-4 botonesInfo order-2 order-lg-1">
                <router-link to="/administracion-de-usuarios">
                  <button class="secondary-button"
                    @click="[infoPersonal.datosContacto = false, codeState = '', emailMatch = true, mailContactoConfirm = '']">{{
                        $t('language.posadasCorporate.infoPersonalEditar.regresar')
                    }}</button>
                </router-link>
              </div>
              <div class="col-12 col-lg-4 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                <button class="button" @click="editSUser(); emailMatch = true; mailContactoConfirm = ''"
                  :disabled="isDisabledFormulario">{{ $t('language.posadasCorporate.infoPersonalEditar.guarMod')
                  }}</button>
              </div>

            </div>

          </form>
        </div>
      </div>
    </div>

    <Footer />

    <!-- Tarifas especiales no disponibles -->
    <modal v-show="isModalEdiatar" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde mt-2 pt-3">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{ modalTitle }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left" v-if="infoPersonal.desHabilitarUsuario">
          {{ $t('language.posadasCorporate.infoPersonalEditar.modalTarEspNoDisp.body') }}
        </p>
        <span v-else></span>
      </template>
      <template slot="footer">
        <router-link to="/administracion-de-usuarios">
          <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModal"
            aria-label="Close modal">
            {{ $t('language.posadasCorporate.infoPersonalEditar.modalTarEspNoDisp.entendido') }}
          </button>
        </router-link>
      </template>
    </modal>

    <!-- Modal PASS IS NO EQUAL -->
    <modal v-show="isModalPass" @close="closeModalNotSamePass" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="danger mt-2 pt-3"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.modales.verifyPass.title') }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.verifyPass.body') }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalNotSamePass()" aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.verifyPass.entendido') }}
        </button>
      </template>
    </modal>

    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.modales.expiredSession.title') }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{ $t('language.posadasCorporate.modales.expiredSession.body') }}</p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeExpiredModal" aria-label="Close modal">{{
            $t('language.posadasCorporate.modales.expiredSession.button')
        }}</button>
      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->

  </div>
</template>

<script>
import Header from '../generales/Header.vue';
import Footer from '../generales/Footer.vue';
import Modal from '../addons/Modal.vue'
import i18n from '../../plugins/i18n';
import SecureLS from 'secure-ls';
import * as GlobalFunctions from "../../utils/GlobalFunctions";
import axios from 'axios';
//KB47296 Start
import { validatePhoneNumber } from "../../utils/GlobalFunctions";
//KB47296 End
import {
  required,
  email,
  sameAs,
} from "vuelidate/lib/validators";
export default {
  name: 'InformacionPersonalEditar',
  components: {
    Header,
    Modal,
    Footer,
  },
  data: () => {
    return {
      telInput: 0,
      banSelectedPais: false,
      contrasenaUsuarioSta: "",
      realNumeroEmple: "",
      validRegexEMPLE: /^[a-zA-Z0-9-_\\ ]+$/,
      emailMatch: true,
      mailContacto: "",
      mailContactoConfirm: "",
      pickedTelelefonoUf: "",
      officeNumber: "",
      homeNumber: "",
      cellNumber: "",
      contrasenaConfirma: "",
      contrasenaUsuario: "",
      passwordNot10M: true,
      passwordNot10: true,
      qwerty: "",
      realCountry: "",
      codeCountry: "",
      codeState: "",
      detailUser: null,
      isExpiredModalVisible: false,
      userName: "",
      passwordMatch: true,
      isModalPass: false,
      enableUser: false,
      ls: new SecureLS({ encodingType: 'aes' }),
      device: 'desktop',
      isModalEdiatar: false,
      modalTitle: i18n.t('language.posadasCorporate.infoPersonalEditar.modalTarEspNoDisp.title'),
      passwordFieldType: '',
      passwordFieldTypeConfirm: '',
      openEye: '__eyeIcon',
      closeEye: '__closeEyeIcon',
      openEyeConfirm: '__eyeIcon',
      closeEyeConfirm: '__closeEyeIcon',
      infoPersonal: {
        //Activador de Icono
        iconoHabitacion: 0,
        iconoActivo: 0,
        // Datos
        datosPersonales: true,
        datosContacto: true,
        contrasena: true,
        datosProforma: true,
        datosRequerimientos: true,
        nombreUsuario: '',
        // Nombre
        nombres: '',
        apellidoP: '',
        apellidoM: '',
        // Numeros
        numEmp: '',
        numFiesta: '',
        numApreciare: '',
        numCentro: '',
        pickedTelelefono: '',
        numTelefonico: '525570464455',
        // tipos de direccion
        pickedDireccion: '',
        direccion: '',
        colonia: '',
        codigoPostal: "",
        mailContacto: '',
        mailContactoCopia: '',
        mailContactoConfirmacion: '',
        //paises
        pais: false,
        paisSeleccionado: '',
        paises: [{
          'nombre': 'México'
        },
        {
          'nombre': 'EEUU'
        },
        {
          'nombre': 'Canada'
        },
        {
          'nombre': 'Colombia'
        },
        {
          'nombre': 'España'
        },
        ],
        //estados
        estado: false,
        estadoSeleccionado: '',
        estados: [
        ],
        ciudad: '',
        contrasenaUsuario: '',
        contrasenaConfirma: '',
        desHabilitarUsuario: false,
        showExtraTypeMobile: false,
      },
      formulario1: {
        personales: '',
        contacto: '',
      },
    }
  },
  validations: {
    mailContacto: {
      required,
      email,
    },
    mailContactoConfirm: {
      required,
      email,
    },
    infoPersonal: {
      mailContacto: {
        required,
        email,
      },
      mailContactoCopia: {
        required,
        email,
      },
      mailContactoConfirmacion: {
        required,
        email,
      },
    }
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth();
    });
  },
  created() {
    if (!GlobalFunctions.validIfGenericUser()) {
      this.chargeCountries()
      this.userName = this.ls.get('Profile').data.username
      this.infoPersonal.nombreUsuario = this.ls.get('Profile').data.username
      this.getUserDetail(this.userName, false)
      let userType = this.ls.get('Profile').data.userType
      let activeUser = this.ls.get('Profile').data.activeUser
      if (activeUser) {
        this.enableUser = true
      } else {
        if (userType == "SUPER_ADMIN") {
          this.enableUser = true
        } else {
          this.enableUser = false
        }
      }
    }
  },
  watch: {
    realNumeroEmple() {
      let str = "";
      if (!this.validRegexEMPLE.test(this.realNumeroEmple)) {
        str = this.realNumeroEmple.substring(0, this.realNumeroEmple.length - 1);
        this.realNumeroEmple = str
      }
    },
    mailContacto() {
      if (this.mailContactoConfirm != "") {
        if (this.mailContactoConfirm == this.mailContacto) {
          this.emailMatch = true
        } else {
          this.emailMatch = false
        }
      } if (this.mailContactoConfirm == "" && this.mailContacto == "") {
        this.emailMatch = true
      }



    },
    mailContactoConfirm() {


      if (this.mailContactoConfirm == this.mailContacto) {
        this.emailMatch = true
      } else {
        this.emailMatch = false
      }
      if (this.mailContactoConfirm == "" && this.mailContacto == "") {
        this.emailMatch = true
      }
    },
    pickedTelelefonoUf() {

      //KB47296 Start
      console.log("@pickedTelelefonoUf")

      switch (this.pickedTelelefonoUf) {
        case "MOB":
          if (this.cellNumber !== "") {
            this.infoPersonal.numTelefonico = this.cellNumber
          }
          break;
        case "HOM":
          if (this.homeNumber !== "") {
            this.infoPersonal.numTelefonico = this.homeNumber
          }
          break;
        case "BUS":
          if (this.officeNumber !== "") {
            this.infoPersonal.numTelefonico = this.officeNumber
          }
          break;
        default:
          break;
      }

      this.isDisabledContacto;

      const auxPhoneNumber = this.infoPersonal.nationalNumber ? this.infoPersonal.nationalNumber : this.infoPersonal.numTelefonico;
      if(this.infoPersonal.areaCode && auxPhoneNumber){
        this.infoPersonal.numTelefonico = validatePhoneNumber(this.infoPersonal.areaCode, auxPhoneNumber, this.pickedTelelefonoUf);
      }else{
        this.infoPersonal.areaCode = "+52";
        this.infoPersonal.numTelefonico = validatePhoneNumber(this.infoPersonal.areaCode, auxPhoneNumber, this.pickedTelelefonoUf);
      }
      
      
      //KB47296 End

    },
    contrasenaConfirma() {
      if (this.contrasenaConfirma.length < 10) {
        this.passwordNot10 = false
      } else {
        this.passwordNot10 = true
      }

    },
    contrasenaUsuario() {
      if (this.contrasenaUsuario.length < 10) {
        this.passwordNot10M = false
      } else {
        this.passwordNot10M = true
      }
    },
    qwerty() {
      this.findingCountry()
    },
    codeCountry() {
      if (this.codeCountry != '') {
        for (var x = 0; x < this.infoPersonal.paises.length; x++) {
          if (this.codeCountry == this.infoPersonal.paises[x].countryCode) {
            this.realCountry = this.infoPersonal.paises[x].nombre;
            this.banSelectedPais = true;
            this.cambiaPais(this.realCountry);
          }
        }
      }
    },
    codeState() {
      if (this.codeState != '') {
        for (var x = 0; x < this.infoPersonal.estados.length; x++) {
          if (this.codeState == this.infoPersonal.estados[x].nombre) {
            this.codeState = this.infoPersonal.estados[x].code
          }
        }
      }
    },
    passwordMatch() {
      if (!this.passwordMatch) {
        this.isModalPass = true
      }
    },

  },
  methods: {
    resetSelectedPais() {
      this.banSelectedPais = false;
      this.infoPersonal.estadoSeleccionado = '';
    },
    outsidePass() {
      if (this.contrasenaConfirma != "") {
        if (this.contrasenaConfirma != this.contrasenaUsuario) {
          this.isModalPass = true
          this.passwordMatch = false
        } else {
          this.isModalPass = false
          this.passwordMatch = true
        }
      }
    },
    outsidePass2() {
      if (this.contrasenaConfirma != this.contrasenaUsuario) {
        this.isModalPass = true
      } else {
        this.isModalPass = false
      }
    },
    validateEmail(email) {
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    },
    editSUser() {
      // Selected policies
      var selectedPolicies = []
      if (this.detailUser.userPolicies != null) {
        for (var i = 0; i < this.detailUser.userPolicies.length; i++) {
          selectedPolicies.push({
            "id": Number(this.detailUser.userPolicies[i].travelPolicyId),
            "priority": Number(this.detailUser.userPolicies[i].policyPriority)
          })
        }
      }
      // Selected properties
      var selectedProperties = []
      if (this.detailUser.properties != null) {
        for (var i = 0; i < this.detailUser.properties.length; i++) {
          selectedProperties.push(
            Number(this.detailUser.properties[i].propertieId),
          )
        }
      }
      //  Edition specifics
      var nagarada = ""
      if (this.detailUser.userType == "ADMIN") {
        nagarada = "ADMIN Web Site"
      } else if (this.detailUser.userType == "AGENTE") {
        nagarada = "AGENTE Web Site"
      }

      axios.post(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_UPDATEUSER, {
        "addres": this.infoPersonal.direccion.toUpperCase(),
        "addres2": this.infoPersonal.colonia.toUpperCase(),
        "centroCostos": this.infoPersonal.numCentro.toUpperCase(),
        "cityName": this.infoPersonal.ciudad.toUpperCase(),
        "codigoPostal": this.infoPersonal.codigoPostal.toUpperCase(),
        "countryCode": this.codeCountry,
        "creditStatus": this.ls.get('Profile').data.creditStatus,  // ?  
        "deactivated": !this.infoPersonal.desHabilitarUsuario,
        "email": this.mailContacto,
        "email2": this.infoPersonal.mailContactoConfirmacion,
        "emailsProform": this.detailUser.emailProform,
        "empleadoNumber": this.realNumeroEmple.toUpperCase(),
        "excellentClubPin": this.infoPersonal.numApreciare.toUpperCase(),
        "fiestaRewarsNumber": this.infoPersonal.numFiesta.toUpperCase(),
        "fiestaRewarsPin": "",
        "firstName": this.infoPersonal.nombres,
        "lastName": this.infoPersonal.apellidoP,
        "middleName": "",
        "motherMaidenName": this.infoPersonal.apellidoM,
        "numberPhone": this.infoPersonal.numTelefonico,
        "numberType": this.pickedTelelefonoUf,
        "password": this.contrasenaUsuario == "" ? this.contrasenaUsuarioSta : this.contrasenaUsuario,
        "policies": selectedPolicies,
        "profileIdNumber": this.detailUser.profile.profileId,
        "propertiesIdList": selectedProperties,
        "recibeNewsLetter": 0,
        "showC2K": this.detailUser.showC2K,
        "showFR": this.detailUser.showFR,
        "showINT": this.detailUser.showINT,
        "showPIF": this.detailUser.showPIF,
        "showPublicRates": this.detailUser.showPublicRates,
        "showRates": this.detailUser.showRates,
        "stateCode": this.codeState,
        "tipoPerfil": "",
        "userId": this.detailUser.userId,
        "userType": this.detailUser.userType,
        "userTypeDescription": nagarada
      }, {
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + this.ls.get("Token").data,
          "Accept-Language": this.ls.get("Language").data,
          "Content-Type": "application/json",
        }
      })
        .then(res => {
          this.codeState = ''
          this.showModal()

        })
        .catch(error => {
          this.codeState = ''

          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Network Error' || (error.response.status < 600 && error.response.status > 403) || (error.response.status < 399 && error.response.status > 299) || error.response.status < 200) {

            this.$router.push({ name: "Error" });


          }

          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          } else {
          }


        })

    },
    findingCountry() {
      var codeCountry = ''
      var ls = new SecureLS({ encodingType: 'aes' });
      var a = ''
      a = ls.get('Token')
      var token = a.data.substr(1);
      var language = ls.get('Language');
      if (this.realCountry != '') {
        for (var x = 0; x < this.infoPersonal.paises.length; x++) {
          if (this.realCountry == this.infoPersonal.paises[x].nombre) {
            codeCountry = this.infoPersonal.paises[x].countryCode
            this.codeCountry = codeCountry
          }
        }
        // Consultar estados
        this.infoPersonal.estados = []
        axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_COUNTRY + `/${codeCountry}/` + process.env.VUE_APP_STATE,
          {
            withCredentials: true,
            credentials: 'include',
            headers: {
              'Authorization': 'Bearer ' + token,
              'Accept-Language': language.data,
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            var resObject = JSON.parse(JSON.stringify(res));
            if (resObject.status == 200 || resObject.status == 201) {
              this.infoPersonal.estados = resObject.data.response
              var on = []
              for (var i = 0; i < this.infoPersonal.estados.length; i++) {
                on.push({
                  nombre: this.infoPersonal.estados[i].stateName,
                  code: this.infoPersonal.estados[i].stateCode
                })
              }
              this.infoPersonal.estados = on
              for (var x = 0; x < on.length; x++) {
                if (this.codeState == on[x].code) {
                  this.infoPersonal.estadoSeleccionado = on[x].nombre
                }
              }
            }
          })
          .catch(error => {
            // Error server
            if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
              this.$router.push({ name: "Error" });
            }
            // Error server 
            let errorObject = JSON.parse(JSON.stringify(error));
            if (errorObject.message == 'Request failed with status code 401') {
              this.clearLocalStorage()
            }
          })
        // Fin de consultar estados
      }
    },

    chargeCountries() {
      // Consultar paises
      axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_COUNTRY,
        {
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: "Bearer " + this.ls.get("Token").data,
            "Accept-Language": this.ls.get("Language").data,
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            var intermidiate = resObject.data.response
            var intermidiate2 = []
            this.infoPersonal.paises = []
            for (var i = 0; i < intermidiate.length; i++) {
              intermidiate2.push({ 'nombre': intermidiate[i].countryName, 'countryCode': intermidiate[i].countryCode })
            }
            this.infoPersonal.paises = intermidiate2
          }
        })
        .catch(error => {
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          }
        })
      // Fin de consultar paises

    },
    autoCompleteEdition(detailUser) {
      this.infoPersonal.nombres = detailUser.firstName != null ? detailUser.firstName : ""
      this.infoPersonal.apellidoP = detailUser.lastName != null ? detailUser.lastName : ""
      this.infoPersonal.apellidoM = detailUser.lastName2 != null ? detailUser.lastName2 : ""
      this.realNumeroEmple = detailUser.employId != null ? detailUser.employId : ""
      this.infoPersonal.numFiesta = detailUser.profile.fiestaRewardsNumber != null ? detailUser.profile.fiestaRewardsNumber : ""
      this.infoPersonal.numApreciare = detailUser.profile.excellencePin != null ? detailUser.profile.excellencePin : ""
      this.infoPersonal.numCentro = detailUser.profile.costCenter != null ? detailUser.profile.costCenter : ""
      this.mailContacto = detailUser.email != null ? detailUser.email : ""
      this.mailContactoConfirm = detailUser.email != null ? detailUser.email : ""

      this.infoPersonal.mailContactoConfirmacion = detailUser.profile.email2 != null ? detailUser.profile.email2 : ""
      this.infoPersonal.direccion = detailUser.profile.address != null ? detailUser.profile.address : ""
      this.infoPersonal.colonia = detailUser.profile.address2 != null ? detailUser.profile.address2 : ""
      this.infoPersonal.codigoPostal = detailUser.profile.codigoPostal != null ? detailUser.profile.codigoPostal : ""
      this.infoPersonal.ciudad = detailUser.profile.cityName != null ? detailUser.profile.cityName : ""
      this.codeCountry = detailUser.profile.countryCode != null ? detailUser.profile.countryCode : ""
      this.codeState = detailUser.profile.stateCode != null ? detailUser.profile.stateCode : ""
      this.officeNumber = ""
      this.pickedTelelefonoUf = ""
      this.cellNumber = ""
      this.infoPersonal.numTelefonico = ""
      //KB47296 Start
      this.infoPersonal.areaCode = ""
      this.infoPersonal.nationalNumber = ""
      //KB47296 End
      this.homeNumber = ""
      if (detailUser.phoneNUmbers != null && detailUser.phoneNUmbers.length != 0) {
        for (var i = 0; i < detailUser.phoneNUmbers.length; i++) {
          if (detailUser.phoneNUmbers[i].type == "MOB") {
            if (detailUser.phoneNUmbers[i].number != null) {
              this.pickedTelelefonoUf = 'MOB'
              this.cellNumber = detailUser.phoneNUmbers[i].number
              this.infoPersonal.numTelefonico = detailUser.phoneNUmbers[i].number
            }
          }
          if (detailUser.phoneNUmbers[i].type == "HOM") {
            if (detailUser.phoneNUmbers[i].number != null) {
              this.pickedTelelefonoUf = 'HOM'
              this.homeNumber = detailUser.phoneNUmbers[i].number
              this.infoPersonal.numTelefonico = detailUser.phoneNUmbers[i].number
            }
          }
          if (detailUser.phoneNUmbers[i].type == "BUS") {
            if (detailUser.phoneNUmbers[i].number != null) {
              this.pickedTelelefonoUf = 'BUS'
              this.officeNumber = detailUser.phoneNUmbers[i].number
              this.infoPersonal.numTelefonico = detailUser.phoneNUmbers[i].number
            }
          }
        }
      }
      if (detailUser.profile.password == null) {
        this.contrasenaUsuarioSta = ""
      } else {
        this.contrasenaUsuarioSta = detailUser.profile.password
      }

    },
    //KB47296 Start
    handleValidatePhoneNumber(phoneObject){
      console.log("@handleValidatePhoneNumber");
      console.log(phoneObject);
      this.isDisabledContacto;
      if(phoneObject.countryCallingCode && phoneObject.nationalNumber){
        this.infoPersonal.areaCode = '+' + phoneObject.countryCallingCode;
        this.infoPersonal.nationalNumber = phoneObject.nationalNumber;
        this.handleCountryChanged({dialCode: phoneObject.countryCallingCode});
      }

      if(this.infoPersonal.nationalNumber === "" && this.infoPersonal.areaCode === ""){
        this.infoPersonal.numTelefonico = ""
      }

      
    },
    handleOnBlurPhoneNumber() {
      console.log("@handleOnBlurPhoneNumber");
      this.isDisabledContacto;
      if(this.infoPersonal.areaCode && this.infoPersonal.nationalNumber){
        this.infoPersonal.numTelefonico = validatePhoneNumber(this.infoPersonal.areaCode, this.infoPersonal.nationalNumber, this.pickedTelelefonoUf);
        this.forceRerender();
      }
    },
    handleCountryChanged(countryObject) {
      console.log("@handleCountryChanged");
      console.log(countryObject);

      this.isDisabledContacto;
      if(countryObject.dialCode){
        this.infoPersonal.areaCode = '+' + countryObject.dialCode;
      }

      if(this.infoPersonal.areaCode && this.infoPersonal.nationalNumber){
        this.infoPersonal.numTelefonico = validatePhoneNumber(this.infoPersonal.areaCode, this.infoPersonal.nationalNumber, this.pickedTelelefonoUf);
      }

    },
    handleOnInputPhoneNumber(number, phoneObject) {
      console.log("@handleOnInputPhoneNumber");
      console.log(number);
      console.log(phoneObject);

      if(phoneObject.countryCallingCode && phoneObject.nationalNumber){
        this.infoPersonal.areaCode = '+' + phoneObject.countryCallingCode;
        this.infoPersonal.nationalNumber = phoneObject.nationalNumber;
      }

      if(number === ""){
        this.infoPersonal.areaCode = "";
        this.infoPersonal.nationalNumber = "";
        this.infoPersonal.numTelefonico = "";
      }
      
      this.isDisabledContacto;
    },
    forceRerender() {
      this.telInput += 1;
    },
    //KB47296 End
    closeExpiredModal() {
      this.isExpiredModalVisible = false;
      var ls = new SecureLS({ encodingType: "aes" });
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: "Login" });
    },
    getUserDetail(userId, enableDetails) {

      axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +
        process.env.VUE_APP_CORPORATEAPI +
        process.env.VUE_APP_CONDU, {

        "userId": userId,
        "clientId": this.ls.get('clientIdAdd').data.toUpperCase()

      },
        {
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + this.ls.get("Token").data,
            "Accept-Language": this.ls.get("Language").data,
            "Content-Type": "application/json"
          }
        }).then(response => {
          this.detailUser = response.data.response

          // Autocomplete for edition
          this.autoCompleteEdition(this.detailUser)
        }).catch(error => {
          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Network Error' || (error.response.status < 600 && error.response.status > 403) || (error.response.status < 399 && error.response.status > 299) || error.response.status < 200) {

            this.$router.push({ name: "Error" });
          }

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          } else {
          }
        })
    },
    clearLocalStorage() {
      this.isExpiredModalVisible = true;

    },
    passwordValidate() {
      if (this.contrasenaUsuario == this.contrasenaConfirma) {
        this.passwordMatch = true
      } else {
        this.passwordMatch = false
      }
    },
    closeModalNotSamePass() {
      this.isModalPass = false
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      this.openEye = this.openEye === '__eyeIcon' ? '__closeEyeIcon' : '__eyeIcon'
    },
    switchVisibilityConfirm() {
      this.passwordFieldTypeConfirm = this.passwordFieldTypeConfirm === 'password' ? 'text' : 'password'
      this.openEyeConfirm = this.openEyeConfirm === '__eyeIcon' ? '__closeEyeIcon' : '__eyeIcon'
    },
    showModal() {
      this.isModalEdiatar = true;
      if (this.infoPersonal.desHabilitarUsuario === true) {
        this.modalTitle = i18n.t('language.posadasCorporate.infoPersonalEditar.modalTarEspNoDisp.title1')
      } else {
        this.modalTitle = i18n.t('language.posadasCorporate.infoPersonalEditar.modalTarEspNoDisp.title')
      }
    },
    closeModal() {
      this.isModalEdiatar = false;
    },
    cambiaPais(pais) {
      this.banSelectedPais = true;
      this.qwerty = pais
      return this.realCountry = pais;
    },
    cambiaEstado(estado) {
      this.codeState = estado
      return this.infoPersonal.estadoSeleccionado = estado;
    },
    // Cerrar inputs
    outsidePais(e) {
      this.infoPersonal.pais = false;
    },
    outsideEstado(e) {
      this.infoPersonal.estado = false;
    },
    /*Eventos para cambios en el ancho de la pagina*/
    getWindowWidth: function (event) {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowWidth > 736 ? this.device = 'desktop' : this.device = 'mobile';
    },
  },
  computed: {
    isDisabledEstado() {
      if (this.banSelectedPais) {
        return false;
      } else {
        return true;
      }
    },
    // infoPersonal.buscador
    filteredListPaises() {
      return this.infoPersonal.paises.filter(pais => {
        return pais.nombre.toLowerCase().includes(this.realCountry
          .toLowerCase())
      })
    },
    filteredListEstado() {
      return this.infoPersonal.estados.filter(estado => {
        return estado.nombre.toLowerCase().includes(this.infoPersonal.estadoSeleccionado
          .toLowerCase())
      })
    },
    // Validador
    isDisabledPersonales() {
      if (this.infoPersonal.nombreUsuario.length > 1 &&
        this.infoPersonal.nombres.length > 2 && this.infoPersonal.apellidoP.length > 2
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledContacto() {

      console.log("@isDisabledContacto")

      if(this.infoPersonal.areaCode && !this.infoPersonal.nationalNumber){
        this.infoPersonal.nationalNumber = this.infoPersonal.numTelefonico
      }
      let phoneLength = 10
      if(this.infoPersonal.nationalNumber && this.infoPersonal.nationalNumber.startsWith("1")){
        phoneLength = 11;
      }


      if (this.pickedTelelefonoUf.length > 2 && String(this.infoPersonal.numTelefonico) &&
        this.mailContacto.length > 3 && this.banSelectedPais
        && this.validateEmail(this.mailContacto) && (this.validateEmail(this.infoPersonal.mailContactoConfirmacion) || this.infoPersonal.mailContactoConfirmacion == "")
        && this.mailContactoConfirm.length > 3 && this.validateEmail(this.mailContactoConfirm) && this.emailMatch
        && this.infoPersonal.areaCode && this.infoPersonal.nationalNumber && this.infoPersonal.nationalNumber.length >= phoneLength
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledFormulario() {
      if (!this.isDisabledContacto || !this.isDisabledPersonales || (this.contrasenaUsuario.length > 9 && this.contrasenaConfirma
        .length > 9 &&
        this.passwordMatch === true && this.realCountry.length > 1
      )

      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  filters: {
    // infoPersonal.buscador
    resalt: function (value, valueFromSearch) {
      if (!value) return ''
      valueFromSearch != '' ? value = value.replace(valueFromSearch,
        '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>'
      ) : value = value;
      return value;
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/config.scss';

.inputUppercase {
  text-transform: uppercase;
}

.relative {
  position: relative;
}

.buttonEye {
  height: 55%;
  width: 10%;
  position: absolute;
  right: 17px;
  top: 30px;
  cursor: pointer;
}

.section-full {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #fff;
  top: 0;
  right: -100%;
  z-index: 10;
  transition: all .3s !important;
  overflow: hidden;
}

.section-full__header {
  background: white;
  padding: 17.5px 50px;
  position: relative;
  border-bottom: 1px solid #e7e8e9;

  button {
    width: 50px;
    height: 56px;
    background: transparent;
    color: #005a83;
    border: none;
    position: absolute;
    left: 0;
    top: 0;
    padding: 0;
    border-right: solid 1px rgba(255, 255, 255, 0.2);

    span {
      font-size: 24px;
    }

    &:focus {
      outline: none;
    }
  }

  h4 {
    margin: 0;
    font-size: 17px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.24;
    letter-spacing: 0.43px;
  }
}

.section-full__body {
  height: calc(100% - 165px);
  padding-bottom: 58px;
  overflow: auto;
}

.section-full__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 15px;
  width: 100%;

  button {
    &:first-child {
      margin-bottom: 15px;
    }
  }
}

.section-full--open {
  right: 0;
  transition: all .3s !important;
}

.form-element,
.resort {
  margin-top: 16px !important;
}

.segundaIlera {
  .form-element {
    margin-top: 16px !important;
  }
}

.resaltar {
  font-weight: 500;
}

.espacio {
  display: flex;
  position: relative;
  min-height: 70vh;
  width: 100%;
  margin-top: 57px;
  padding-top: 32px;
}

.pasos {
  color: $grayBrownish;
  font-size: $font-size-biglarge;
  font-weight: 300;
}

.PC-color--colorBase3 {
  color: #0c5458;
  font-size: $font-size-exlarge;
}

.ativePaso {
  color: #0c5458;
  font-size: $font-size-biglarge;
  font-weight: 500;
}

.replicar {
  color: #0c5458;
  font-weight: 500;
  cursor: pointer;
}

// Formulario
.botones {
  margin-bottom: 45px;
}

input:disabled {
  background-color: #f8f8f8;
}

// datos
.datos {
  margin-top: 0px;
  margin-bottom: 40px;

  i {
    font-size: 18px;
  }

  .navi {
    float: right;
  }

  .editarDatos {
    font-size: $font-size-base;
    color: #0c5458;
    float: right;
  }

  .datoTitle {
    font-size: $font-size-exlarge;
    font-weight: bold;
  }

  .campos {
    border-bottom: 1px solid $colorBase5;

    .datos {
      padding-bottom: 24px;
    }

    .tituloDatos {
      margin: 0;
      color: $grayBrownish;
      font-size: $font-size-large;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }

    .camposActive {
      color: #0c5458;
      font-weight: 500;
    }

    .tituloDatosEditar {
      margin: 0;
      color: #006900;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }

    .cardsInfo {
      background-color: #d1ecf1;

      .nota {
        font-size: $font-size-base;
        color: $grayShadeDark;
      }

      .notaAzul {
        font-size: $font-size-base;
        color: $colorBase2;
        font-weight: 500;
      }
    }
  }

  @media (max-width: 736px) {
    .buscadorCard {
      width: 185% !important;
      padding: 20px !important;
      border: 1px solid #e7e8e9 !important;
    }
  }

  .botonesInfo {
    left: 50%;
  }

  @media only screen and (max-width: 992px) {
    .botonesInfo {
      left: 0;
    }

    .espacio {
      margin-top: 200px;
    }
  }
}

.barTop {
  display: none;
}

.barRight {
  display: block;
}

@media only screen and (max-width: 992px) {
  .espacio {
    margin-top: 100px;
  }

  .barTop {
    display: block;
  }

  .barRight {
    display: none;
  }
}

.c-modal-footer button {
  max-width: 100% !important;
}
</style>